import { http } from "~/utils";
export default {
    getVoaSummary: async (page = 1, filters = {}) => {
        const request_filters = { ...filters, page };
        return http
            .get("/voa/summary/", {
                params: request_filters
            })
            .then(response => ({
                list: response.data.results,
                pagination: {
                    actual: response.data.actual,
                    count: response.data.count,
                    next: response.data.next,
                    pages: response.data.pages,
                    previous: response.data.previous
                }
            }));
    },
    requestSummaryReport: async () => {
        return await http.post("/voa/summary/report/").then(response => response.data);
    }
};
